"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SearchResult = _interopRequireDefault(require("./SearchResult"));

var _globals2 = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getIndexForSearchType(type) {
  var _globals;

  var communityId = (_globals = (0, _globals2.default)('communityId')) !== null && _globals !== void 0 ? _globals : '';

  switch (type) {
    case 'community':
      return communityId;

    case 'zendesk':
      return "".concat(communityId, "-zendesk");

    case 'freshdesk':
      return "".concat(communityId, "-freshdesk");

    case 'salesforce':
      return "".concat(communityId, "-salesforce");

    case 'skilljar':
      return "".concat(communityId, "-skilljar");

    default:
      return "".concat(communityId, "-federated");
  }
}

var SearchResultsSection = function SearchResultsSection(_ref) {
  var title = _ref.title,
      searchMetadata = _ref.searchMetadata,
      hits = _ref.hits,
      highlightedIndex = _ref.highlightedIndex,
      getItemProps = _ref.getItemProps,
      previousResultsCount = _ref.previousResultsCount,
      type = _ref.type,
      viewAllUrl = _ref.viewAllUrl,
      setHighlightedIndex = _ref.setHighlightedIndex;
  if (!hits.length) return null;
  var sectionId = btoa(viewAllUrl);
  return (0, _preact.h)("div", {
    role: "none",
    onMouseLeave: function onMouseLeave() {
      setHighlightedIndex(-1);
    }
  }, title ? (0, _preact.h)("div", {
    className: "algolia-search-results-section__title"
  }, (0, _preact.h)("span", {
    className: "algolia-search-results-section__title-label",
    id: sectionId,
    role: "heading",
    "aria-level": 2
  }, title), viewAllUrl !== '' ? (0, _preact.h)("a", {
    "data-track-type": "click",
    "data-element-name": "Algolia search view all link",
    className: "algolia-search-results-section__title-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(viewAllUrl),
    "aria-describedby": sectionId
  }, (0, _preact.h)(_phrase.default, {
    p: "live.search.view.all"
  })) : null) : '', (0, _preact.h)("ul", {
    className: "algolia-search-results",
    role: "listbox",
    "aria-labelledby": sectionId
  }, hits.map(function (hit, index) {
    var position = searchMetadata.hitsPerPage * searchMetadata.page + index + 1;
    return _objectSpread(_objectSpread({}, hit), {}, {
      position: type === 'community' ? position + previousResultsCount : position,
      // bump if there's an answer
      queryID: searchMetadata.queryID,
      indexName: getIndexForSearchType(type)
    });
  }).map(function (hit, defaultIndex) {
    var _hit$topic_url;

    var index = defaultIndex + previousResultsCount;
    hit.topic_url = (_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : hit.url;
    return (0, _preact.h)(_SearchResult.default, {
      key: hit.objectID,
      isHighlited: highlightedIndex === index,
      hit: hit,
      type: type,
      index: index,
      getItemProps: getItemProps
    });
  })));
};

var _default = SearchResultsSection;
exports.default = _default;